<template>
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
                    <div class="f_item">
                        <span class="f_l">应用编码：</span>
                        <span class="f_v">{{modalState.appcode}}</span>
                    </div>

                    <div class="f_item">
                        <span class="f_l">操作类型：</span>
                        <span :class="oprationClass[modalState.actiontype]" >{{oprationname[modalState.actiontype]}}</span>
                    </div>


                    <div class="f_item">
                        <span class="f_l">配置项：</span>
                        <span class="f_v">{{modalState.configitem}}</span>
                    </div>


                    <div class="f_item">
                        <span class="f_l">操作人：</span>
                        <span class="f_v">{{modalState.createusername}}</span>
                    </div>


                    <div class="f_item">
                        <span class="f_l">操作人编码：</span>
                        <span class="f_v">{{modalState.createuser}}</span>
                    </div>

                    <div class="f_item">
                        <span class="f_l">备注：</span>
                        <span class="f_v">{{modalState.remark}}</span>
                    </div>
                    
                    <div class="f_item">
                        <span class="f_l">操作时间：</span>
                        <span class="f_v">{{modalState.createtime}}</span>
                    </div>

                    <div class="f_item">
                        <span class="f_l">修改前：</span>
                    </div>

                    <xmlEditor ref="currentEditor"></xmlEditor>
                    <div class="f_item">
                        <span class="f_l">修改后：</span>
                    </div>


                    <xmlEditor ref="sourceEditor"></xmlEditor>



        </a-card>
</template>
<script>
import xmlEditor from './xmlEditor'

export default {
    data() {
        return {
            c_title:'编辑',
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            currentLanguage:'xml',
            currentLanguagesource:'xml',
            formItemLayout:'horizontal',
            oprationname : {
                'create':'新增',
                'update':'更新',
                'delete':'删除'
            },
            oprationClass : {
                'create':'f_v color_green',
                'update':'f_v color_blue',
                'delete':'f_v color_red'
            },
            modalState:{
                id:'',
                actiontype:'',
                appcode:'',
                configitem:'',
                configvaluesource:'',
                
                configvalue:'',
                createtime:'',
                createusername:'',
                createuser:'',
                remark:''
            }
        };
    },

    components:{
        xmlEditor
    },
    methods: {

        
    },
    mounted(){
        const {query} = this.$route;
        if(query.id){
            this.c_title = "编辑配置"
            let c_params = {}
            c_params.id = query.id;
            this.$store.dispatch({
                type: "configcenter/detailConfigLogPage",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.modalState=  result
                    this.$refs.sourceEditor.handleWrapp(result.configvaluesource)
                    this.$refs.currentEditor.handleWrapp(result.configvalue)
                    
                }
                else{
                    this.message.error("未找到对应配置")
                }
            })
        }
        else{
            this.c_title = "新增配置"
        }
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}

.f_l{
    font-size: 16px;
    color: #676666;
}

.f_v{
    font-size: 16px;
    color: black;
}

.f_item{
    padding-bottom: 10px;
}


.color_green{
    color: green;
}

.color_blue{
    color: blue;
}

.color_red{
    color: red;
}
</style>
